<template>
    <div class="nonSyntenicOrth-div">
        <div>
            <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">Nonsyntenic Orth</h2>
        </div>
        <div class="search-form">
            <h2 style="text-align: center;margin-top: 20px;font-size: 22px;color: #407338;">Search across gene ID</h2>
            <a style="text-align: left;float: left;font-size: 18px;margin: 10px auto 5px 20px;color: #407338;">
                "<b>query</b>" indicates blast query file
            </a>
            <a style="text-align: left;float: left;font-size: 18px;margin: 5px auto 15px 20px;color: #407338;">
                "<b>subject</b>" indicates blast library file
            </a>
            <el-form class="demo-form-inline" style="margin-top: 15px" size="small" @submit.native.prevent label-width="120px">
                <el-form-item label="query gene ID">
                    <el-input style="width: 180px" v-model="search_gene" :disabled="isSearch" placeholder="Input Gene ID" @keyup.enter.native="search_nonsyntenic"></el-input>
                </el-form-item>
                <el-form-item label="subject gene ID">
                    <el-input style="width: 180px" v-model="subject_gene" :disabled="isSubject" placeholder="Input Gene ID" @keyup.enter.native="search_nonsyntenic"></el-input>
                </el-form-item>
                <el-form-item style="text-align: left" label="query genome">
                    <el-select style="width: 180px;margin-right: 7px"  v-model="query_genome">
                        <template v-for="genome in genome_sheet">
                            <el-option :key="genome" :label="genome.species" :value="genome.species"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item style="text-align: left" label="subject genome">
                    <el-select style="width: 180px;margin-right: 7px"  v-model="subject_genome">
                        <template v-for="genome in subject_genome_list">
                            <el-option :key="genome" :label="genome" :value="genome"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item style="text-align: left">
                    <el-button style="width: 85px" type="primary" @click="search_nonsyntenic"><b>Search</b></el-button>
                    <el-button style="width: 65px;margin-left: 30px" type="primary" @click="example_help">Help</el-button>
                </el-form-item>
                <el-form-item style="text-align: left;" label="example">
                    <el-button style="width: 110px;font-size: 13px" type="primary" @click="searchBra039973"><i>Bra039973</i></el-button>
                </el-form-item>
                <el-form-item v-if="show_result">
                    <el-button style="width: 280px;font-weight: bold;margin-left: -100px" @click="exportExcel">Export result as Excel</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="nonsyntenic-result" v-if="show_result">
            <el-table
                id="nonsyntenic_show"
                :data="non_syntenic_sheet"
                @mouseover.native="addTitle"
                height="500px"
                border
                header-cell-style="color:#407338;text-align:center;font-size:18px"
                cell-style="color:#407338;text-align:center">
                <el-table-column prop="query_gene" :label="query_genome" width="140px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.query_gene[1] === 1" type="text" size="small" @click="handleGene(scope.row.query_gene)" style="color: #3742fa">
                            {{scope.row.query_gene[0]}} (T)
                        </el-button>
                        <el-button v-else type="text" size="small" @click="handleGene(scope.row.query_gene)" style="color: #3742fa">
                            {{scope.row.query_gene[0]}}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="subject_gene" :label="subject_genome" width="140px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.subject_gene[1] === 1" type="text" size="small" @click="handleGene(scope.row.subject_gene)" style="color: #3742fa">
                            {{scope.row.subject_gene[0]}} (T)
                        </el-button>
                        <el-button v-else type="text" size="small" @click="handleGene(scope.row.subject_gene)" style="color: #3742fa">
                            {{scope.row.subject_gene[0]}}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="identity" label="Identity" width="90px"></el-table-column>
                <el-table-column prop="query_coverage" label="q coverage" width="124px"></el-table-column>
                <el-table-column prop="subject_coverage" label="s coverage" width="124px"></el-table-column>
                <el-table-column prop="subject_coverage" label="e-value" width="94px"></el-table-column>
            </el-table>

            <div id="waiting" v-if="isWaiting">
                <img src="../assets/img/waiting.gif" style="height: 200px;width: 200px">
            </div>
            <FunctionSelection v-if="boxtarget" :target="selection_gene"
                @hideBox="hideSelectionBox"
                @watchSubFunction="common.searchSubFunction"></FunctionSelection>
            <FucntionSelectionBra v-if="Bra_boxtarget" :target="selection_gene"
                @hideBox="hideBraSelectionBox"
                @watchSubFunctionBra="common.searchSubFunction"></FucntionSelectionBra>
            <FunctionSelectionAth10 v-if="Ath_boxtarget" :target="selection_gene"
                @hideBox="hideAth10SelectionBox"
                @watchSUbFunctionAth10="common.searchSubFunction"></FunctionSelectionAth10>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import XLSX from "xlsx";
    import FileSaver from "file-saver";
    import FunctionSelection from "../components/FunctionSelection";
    import FucntionSelectionBra from "../components/FucntionSelectionBra";
    import FunctionSelectionAth10 from "../components/FunctionSelectionAth10";

    export default {
        name: "NonSyntenicOrthologs",
        data () {
            return {
                genome_sheet: {},
                search_gene: this.$route.query.Gene,
                subject_gene: '',
                query_genome: '',
                show_result: 0,
                Ath_boxtarget: 0,
                isSearch: false,
                isSubject: false,
                boxtarget: 0,
                Bra_boxtarget: 0,
                isWaiting: 0,
                selection_gene: '',
                non_syntenic_sheet: {},
                subject_genome: 'Ath_TAIR_V10.1',
                subject_genome_list: ['Ath_TAIR_V10.1', 'Brara_Chiifu_V1.5', 'Brara_Chiifu_V3.0', 'Braol_JZS_V2.0']
            }
        },
        mounted() {
            this.judgeStyle();
            this.get_genomes_show();
            this.judge_search_gene();
        },
        components: {
            FunctionSelection,
            FucntionSelectionBra,
            FunctionSelectionAth10
        },
        methods: {
            judgeStyle() {
                if (document.documentElement.clientHeight <= document.body.clientHeight) {
                    document.getElementsByTagName('html')[0].style.height = '';
                    document.getElementsByTagName('body')[0].style.height = '';
                } else {
                    document.getElementsByTagName('html')[0].style.height = '100%';
                    document.getElementsByTagName('body')[0].style.height = '100%';
                }
            },
            get_genomes_show() {
                axios({
                    url:'http://39.100.233.196:8001/api/get-species-information/',
                    type: 'json',
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data);
                    this.genome_sheet = res.data.slice(0, res.data.length-1)
                })
            },
            judge_search_gene() {
                if (this.search_gene.substr(0, 2) == 'AT') {
                    // console.log('OKOKOOK');
                    this.subject_genome = 'Brapa15';
                    this.search_nonsyntenic();
                }
                else if (typeof this.search_gene !== 'undefined') {
                    this.search_nonsyntenic()
                }
            },
            search_nonsyntenic() {
                this.isWaiting = 1;
                var subject_genome = this.subject_genome;
                var query_genome = this.query_genome;
                var subject_gene = this.subject_gene;
                var search_gene = this.search_gene;
                axios({
                    url: 'http://39.100.233.196:8001/api/search-nonsyntenic-orth-gene/',
                    type: 'json',
                    timeout: 30000,
                    params: {
                        subject_genome,
                        query_genome,
                        subject_gene,
                        search_gene,
                    },
                    method: 'get',
                }).catch((err) => {                                     // eslint-disable-line no-unused-vars
                    // console.log(err);
                    alert("Please input correct information");
                    this.isWaiting = 0;
                    // setTimeout(location.reload(), 1000)
                }).then((res)=>{
                    // console.log(res.data);
                    this.query_genome = res.data[res.data.length-2];
                    this.subject_genome = res.data[res.data.length-1];
                    this.non_syntenic_sheet = res.data.slice(0, res.data.length-2);
                    // console.log(this.non_syntenic_sheet);
                    this.isWaiting = 0;
                    this.show_result = 1;
                })
            },
            handleGene(gene) {
                this.selection_gene = gene[0]
                // console.log(gene[0])
                console.log(gene)
                if (gene[2] == 'Ath_TAIR_V10.1') {
                    this.Ath_boxtarget = 1;
                    this.boxtarget = 0;
                    this.Bra_boxtarget = 0;
                } else if (gene[2].slice(0, 3) == "Bra") {
                    this.Ath_boxtarget = 0;
                    this.boxtarget = 0;
                    this.Bra_boxtarget = 1;
                } else {
                    this.Ath_boxtarget = 0;
                    this.boxtarget = 1;
                    this.Bra_boxtarget = 0;
                }
            },
            addTitle(e) {
                let target_el = e.target;
                if (target_el.title) return;
                target_el.title = target_el.innerText;
            },
            example_help() {
                this.$router.push({path: '../Userguide/'})
            },
            searchBra039973() {
                this.search_gene = 'Bra039973';
                this.subject_genome = 'Ath_TAIR_V10.1';
                this.query_genome = '';
                this.search_nonsyntenic();
            },
            functionSelection (value){
                // console.log(value);
                this.boxtarget = 1;
                this.Ath_boxtarget = 0;
                this.show_tandem = 0;
                this.selection_gene = value;
            },
            functionSelectionAth10 (value){
                // console.log(value);
                this.Ath_boxtarget = 1;
                this.boxtarget = 0;
                this.show_tandem = 0;
                this.selection_gene = value;
            },
            hideSelectionBox () {
                this.boxtarget = 0;
            },
            hideBraSelectionBox () {
                this.Bra_boxtarget = 0;
            },
            hideAth10SelectionBox () {
                this.Ath_boxtarget = 0;
            },
            searchGeneSeq (geneID) {
                // console.log(geneID)
                let routeUrl = this.$router.resolve({
                    path: "../GeneSequence/",
                    query: {Gene: geneID}
                });
                window.open(routeUrl.href, '_blank');
            },
            exportExcel() {
                // 为el-table添加一个id：out-table
                // 当el-table使用了fixed时会导出两次数据，所以要先进行判断
                var fix = document.querySelector('.el-table__fixed');
                var wb;
                if (fix) {
                    // 如果有fixed，先移除，然后再添加上
                    wb = XLSX.utils.table_to_book(document.querySelector("#nonsyntenic_show").removeChild(fix))
                    document.querySelector("#nonsyntenic_show").appendChild(fix)
                }else{
                    wb = XLSX.utils.table_to_book(document.querySelector("#nonsyntenic_show"))
                }
                var wbout = XLSX.write(wb, {
                    bookType: 'xlsx',
                    bookSST: true,
                    type: "array"
                });
                if (this.subject_gene == '') {
                    try {
                        FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        this.search_gene + '_nonsyntentc_Orth.xlsx'
                        )
                    } catch (e) {
                        if (typeof console !== 'undefined') console.log(e, wbout);
                    }
                } else {
                    try {
                        FileSaver.saveAs(
                        new Blob([wbout], {
                            type: "application/octet-stream"
                        }),
                        // 导出的文件名称
                        this.subject_gene + '_nonsyntentc_Orth.xlsx'
                        )
                    } catch (e) {
                        if (typeof console !== 'undefined') console.log(e, wbout);
                    }
                }
                return wbout;
            }
        },
        watch: {
            'search_gene': {
                handler: function (val) {
                    if (val.substr(0, 2) == 'AT') {
                        this.query_genome = 'Ath_TAIR_V10.1';
                    }
                    if (val.length != 0) {
                        this.isSubject = true;
                        this.query_genome = '';
                        this.subject_gene = '';
                    } else {
                        this.isSubject = false
                    }
                },
                deep: true
            },
            'subject_gene': {
                handler: function (val) {
                    if (val.length != 0) {
                        this.isSearch = true;
                        this.subject_genome = '';
                        this.search_gene = '';
                    } else {
                        this.isSearch = false
                    }
                },
                deep: true
            },
            'subject_genome': {
                handler: function(newval, oldval) {                             // eslint-disable-line no-unused-vars
                    // console.log(newval, oldval)
                    if (oldval != '' && this.query_genome != '') {
                        this.query_genome = '';
                    }
                }
            }
        }
    }
</script>

<style>

    .nonSyntenicOrth-div {
        overflow:auto;
        background: #E8F2EC;
        width: 1200px;
        margin: 0 auto;
    }

    .nonSyntenicOrth-div .search-form {
        margin: 20px auto 20px 50px;
        float: left;
        border-right: 1px solid #407338;
        width: 350px;
        height: 500px;
    }

    .nonSyntenicOrth-div .nonsyntenic-result {
        float: left;
        width: 730px;
        margin: 20px auto 50px 30px;
    }

    .nonSyntenicOrth-div .el-form-item__label{
        color: #407338;
    }

    .nonSyntenicOrth-div .search-form .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    .nonSyntenicOrth-div .search-form .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }

    #waiting {
        text-align: center;
        position: fixed;
        width: 200px;
        height: 200px;
        /*background: rgba(119, 176, 127, 0.35);*/
        left: 0;
        right: 0;
        top: 35%;
        margin: 0 auto;
    }

    .nonSyntenicOrth-div .el-select-dropdown__item {
        color: #407338;
    }

    .nonSyntenicOrth-div .el-input__inner {
        color: #407338;
    }


</style>